import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import AxiosInstance from "../axios";

createApp(App).use(store).use(store).use(router).mount("#app");

const token = sessionStorage.getItem("token");
if (token) {
  AxiosInstance.defaults.headers.common["Authorization"] = token;
}
